import { render, staticRenderFns } from "./modelAttribute.vue?vue&type=template&id=c195ffb4&scoped=true&"
import script from "./modelAttribute.vue?vue&type=script&lang=js&"
export * from "./modelAttribute.vue?vue&type=script&lang=js&"
import style0 from "./modelAttribute.vue?vue&type=style&index=0&id=c195ffb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c195ffb4",
  null
  
)

export default component.exports